import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { PRIMARY_BUTTON, SECONDARY_BUTTON } from "./buttonStyles";

type EditPanelProps = {
  onSave: () => void | Promise<void>;
  onCancel: () => void;
  /** Disables both buttons while the save request runs. */
  saving?: boolean;
  /** Why the last save failed; shown under the fields. */
  error?: string | null;
  saveLabel?: string;
  /** The form fields. */
  children: ReactNode;
};

export function EditPanel({
  onSave,
  onCancel,
  saving,
  error,
  saveLabel,
  children,
}: EditPanelProps) {
  const { t } = useTranslation();

  return (
    <div className="w-full rounded-lg border border-gray-200 bg-gray-50 p-4">
      {children}
      {error && (
        <p role="alert" className="mt-3 text-sm text-red-600">
          {error}
        </p>
      )}
      <div className="mt-4 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onSave()}
          disabled={saving}
          className={PRIMARY_BUTTON}
        >
          {saveLabel ?? t("settings_save")}
        </button>
        <button
          type="button"
          onClick={onCancel}
          disabled={saving}
          className={SECONDARY_BUTTON}
        >
          {t("settings_cancel")}
        </button>
      </div>
    </div>
  );
}
